import { ConfirmPositiveModal } from '@/shared/components/confirmation'
import { confirmationCautionButtonSx } from '@/shared/components/confirmation/confirmationModalStyles'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  confirming: boolean
}

/** BFP-616 — reactivation confirmation body must match the user-story copy exactly. */
const REACTIVATE_CONFIRM_BODY =
  'Are you sure you want to reactivate this instrument? Signal Providers will be notified via in-app push notification and response collection will resume immediately.'

export function ReactivateInstrumentModal({
  open,
  onClose,
  onConfirm,
  confirming,
}: Readonly<Props>) {
  return (
    <ConfirmPositiveModal
      open={open}
      iconVariant="play"
      headline="Reactivate Instrument"
      bodyLines={[REACTIVATE_CONFIRM_BODY]}
      dismissLabel="Cancel"
      confirmLabel="Yes, Reactivate"
      confirmButtonSx={confirmationCautionButtonSx}
      confirmDisabled={confirming}
      confirmPending={confirming}
      onDismiss={onClose}
      onConfirm={() => void Promise.resolve(onConfirm())}
      dialogTestId="launch-reactivate-instrument-modal"
      dismissTestId="launch-reactivate-instrument-cancel"
      confirmTestId="launch-reactivate-instrument-confirm"
    />
  )
}
